import { Body, TextLink } from '@assembly-js/design-system';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as Constants from 'src/constants';
import { PAYMENTS_PAGE } from 'src/constants';
import { useSettingsPageRedirection } from 'src/legacy/components/Settings/useSettingsPageRedirection';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { RootState } from 'src/store/reduxTypes';
import { setFormPageChanged } from 'src/store/ui/actions';
import * as UserUtils from 'src/utils/UserUtils';

interface Props {
  reason: string;
}

/**
 * @description This is deprecated. Please use the new DisableAutoChargeTooltip component in src/features/payments/components/DisableAutoChargeTooltip.tsx
 * @deprecated use the new component in src/features/payments/components/DisableAutoChargeTooltip.tsx
 */
const DisableBillingTooltip: React.FC<Props> = ({ reason }) => {
  const dispatch = useDispatch();
  const permissions = useSelector(
    (state: RootState) => state.user.data?.permissions,
  );

  const canSetupBanking = UserUtils.hasPermission(
    Constants.PERM_MOD_SETTINGS_BILLING,
    permissions,
  );

  const { goToSettings: goToPaymentsSettings } = useSettingsPageRedirection(
    canSetupBanking,
    PAYMENTS_PAGE.path,
  );

  const openBankingSettings = () => {
    // clear form page changes when opening payment settings to prevent unsaved changes dialog when connecting bank account
    dispatch(setFormPageChanged(false));
    goToPaymentsSettings();
  };

  if (reason === 'no-payment-method') {
    return (
      <BaseTypography fontType="12Medium">
        To charge a client directly you must add a payment method
      </BaseTypography>
    );
  }

  if (reason === 'non-usd-subscription') {
    return (
      <BaseTypography fontType="12Medium">
        At this time only USD currency subscriptions are supported. You can
        still create invoices in other currencies.
      </BaseTypography>
    );
  }

  if (reason === 'no-banking-info') {
    if (canSetupBanking) {
      return (
        <Body size="sm">
          <TextLink className="inline" onClick={openBankingSettings}>
            Connect your bank account
          </TextLink>
          &nbsp;to get paid by your clients.
        </Body>
      );
    }
    return (
      <Body size="sm">
        To charge a client directly please contact an admin user to connect your
        bank
      </Body>
    );
  }

  return null;
};

export default DisableBillingTooltip;
